// The action plan route keeps a "no-action-plan" placeholder in place of the
// assessment id while there is no assessment to show. It is a routing marker,
// never a real id, so anything that builds a request out of the route param has
// to read it as "nothing selected" instead of sending it to the API.
export const NO_ACTION_PLAN_ROUTE_ID = "no-action-plan";

export const normalizeAssessmentId = (value) => {
   const normalizedValue = String(value ?? "")
      .trim()
      .replace(/^"(.*)"$/, "$1");
   if (!normalizedValue) return null;
   const lowerValue = normalizedValue.toLowerCase();
   if (lowerValue === NO_ACTION_PLAN_ROUTE_ID || lowerValue === "null" || lowerValue === "undefined") {
      return null;
   }
   return normalizedValue;
};
